import { Divider, Form, Input } from 'antd'
import { tabFields } from '~app/configuration/labels'
import type { DocumentScanMetadata } from '~app/graph/generated/graphql'
import i18n from '~app/i18n/i18n'

interface Props {
  scanMetadata?: DocumentScanMetadata | null
}

const ScanMetadata = ({ scanMetadata }: Props) => {
  return scanMetadata ? (
    <>
      <Divider
        orientation="left"
        orientationMargin={0}
        style={{ margin: '8px 0' }}
      >
        {i18n.t('documentView.scanMetadata.title')}
      </Divider>
      {scanMetadata.scanId && (
        <Form.Item
          label={i18n.t('documentView.scanMetadata.scanId.title')}
          style={{ marginBottom: 8 }}
        >
          <Input
            defaultValue={scanMetadata.scanId}
            placeholder={i18n.t('documentView.scanMetadata.scanId.placeholder')}
            tabIndex={tabFields.scanMetadata}
            disabled
          />
        </Form.Item>
      )}
      {scanMetadata.date && (
        <Form.Item
          label={i18n.t('documentView.scanMetadata.scanDate.title')}
          style={{ marginBottom: 8 }}
        >
          <Input
            defaultValue={scanMetadata.date}
            placeholder={i18n.t(
              'documentView.scanMetadata.scanDate.placeholder'
            )}
            tabIndex={tabFields.scanMetadata}
            disabled
          />
        </Form.Item>
      )}
    </>
  ) : null
}

export default ScanMetadata
